import React from 'react'
import AllRidesTable from '../../components/allRidesTable/AllRidesTable'

const AllRides = () => {

  return (
    <div className="ta__dashboard">
    <div className="ta__dashboard__breadcrumb">
      <h2 className="f-24">Manage Rides</h2>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item f-18">
            <a href="/" className="text-gray">
              Home
            </a>
          </li>
          <li
            className="breadcrumb-item f-18 text-black active"
            aria-current="page"
          >
            All Rides
          </li>
        </ol>
      </nav>
    </div>
    <div className="ta__dashboard__body">
      <div className="ta__dashboard_sort">
        <form action="" className="d-flex flex-wrap">
          <div className="col-md-4 col-sm-6 col-12">
            <div className="form_control">
              <label htmlFor="">Status</label>
              <div className="ta__country_dropdown">
                <select className="" name="role">
                  <option value="all">All</option>
                  <option value="on-hold">On hold</option>
                  <option value="Pending">Pending</option>
                  <option value="In progress">In progress</option>
                  <option value="Pending Docs">Pending Docs</option>
                  <option value="Processing in progress">
                    Processing in progress
                  </option>
                  <option value="Invalid documents">Invalid documents</option>
                  <option value="Valid documents">Valid documents</option>
                  <option value="Training planned">Training planned</option>
                  <option value="Absent from training">
                    Absent from training
                  </option>
                  <option value="Rejected post approval">
                    Rejected post approval
                  </option>
                  <option value="Sign contract">Sign contract</option>
                  <option value="Rejected">Rejected</option>
                  <option value="Approved">Approved</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 col-12">
            <div className="form_control">
              <label htmlFor="">Service</label>
              <div className="ta__country_dropdown">
                <select className="" name="role">
                  <option value="">All</option>
                  <option value="">USA</option>
                  <option value="">India</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 col-12">
            <div className="form_control">
              <label htmlFor="">Driver</label>
              <div className="ta__country_dropdown">
                <select className="" name="role">
                  <option value="">All</option>
                  <option value="">USA</option>
                  <option value="">India</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 col-12">
            <div className="form_control">
              <label htmlFor="district">District</label>
              <div className="ta__country_dropdown">
                <select className="" name="district">
                  <option value="All">All</option>
                  <option value="Ahmedabad">Ahmedabad</option>
                  <option value="Amreli">Amreli</option>
                  <option value="Banaskantha">Banaskantha</option>
                  <option value="Bharuch">Bharuch</option>
                  <option value="Bhavnagar">Bhavnagar</option>
                  <option value="Dang">Dang</option>
                  <option value="Jamnagar">Jamnagar</option>
                  <option value="Junagadh">Junagadh</option>
                  <option value="Kheda">Kheda</option>
                  <option value="Kachchh">Kachchh</option>
                  <option value="Mehsana">Mehsana</option>
                  <option value="Panchmahal">Panchmahal</option>
                  <option value="Rajkot">Rajkot</option>
                  <option value="Sabarkantha">Sabarkantha</option>
                  <option value="Surat">Surat</option>
                  <option value="Surendranagar">Surendranagar</option>
                  <option value="Vadodara">Vadodara</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 col-12">
            <div className="form_control">
              <label htmlFor="">Suspended reason</label>
              <div className="ta__country_dropdown">
                <select className="" name="role">
                  <option value="">All</option>
                  <option value="DRIVER_UNVERIFIED">DRIVER_UNVERIFIED</option>
                  <option value="EXPIRED_CONTRACT">EXPIRED_CONTRACT</option>
                  <option value="NOT_VERIFIED">NOT VERIFIED</option>
                  <option value="REASON_1">REASON_1</option>
                  <option value="REASON_2">REASON_2</option>
                  <option value="TOTO">TOTO</option>
                  <option value="TRIP_DRIVER_CANCELED_10">
                    TRIP_DRIVER_CANCELED_10
                  </option>
                  <option value="TRIP_DRIVER_COMING_CANCELED_20">
                    TRIP_DRIVER_COMING_CANCELED_20
                  </option>
                  <option value="TRIP_DRIVER_COMING_CANCELED_60">
                    TRIP_DRIVER_COMING_CANCELED_60
                  </option>
                  <option value="TRIP_DRIVER_COMING_RIDER_CANCELED_60">
                    TRIP_DRIVER_COMING_RIDER_CANCELED_60
                  </option>
                  <option value="UNPAID">UNPAID</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </div>

      <AllRidesTable />
    </div>
  </div>
  )
}

export default AllRides